export function deepClone(obj, map = new WeakMap()) {
    // 基本数据类型直接返回
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
  
    // 处理循环引用
    if (map.has(obj)) {
      return map.get(obj);
    }
  
    // 处理日期类型
    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }
  
    // 处理正则表达式
    if (obj instanceof RegExp) {
      return new RegExp(obj);
    }
  
    // 处理对象和数组
    const result = Array.isArray(obj) ? [] : {};
    map.set(obj, result);
  
    for (const key of Object.keys(obj)) {
      result[key] = deepClone(obj[key], map);
    }
  
    return result;
  }
  
//   // 使用示例
//   const original = {
//     name: 'Alice',
//     age: 30,
//     address: {
//       city: 'Wonderland',
//       street: '123 Rabbit Hole',
//     },
//     hobbies: ['Reading', 'Gardening'],
//     dateOfBirth: new Date('1994-08-01'),
//     regex: /abc/i
//   };
  
//   const copy = deepClone(original);
//   original.name='jack'
//   console.log(copy);
  